import api from './api';

const userService = {
  // Get current user profile
  getCurrentUser: async () => {
    try {
      const response = await api.get('/users/me');
      return response.data;
    } catch (error) {
      console.error('Error getting current user:', error);
      throw error;
    }
  },

  // Update user profile
  updateProfile: async (userData) => {
    try {
      const response = await api.put('/users/me', userData);
      return response.data;
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  },

  // Get verification token
  getVerificationToken: async () => {
    try {
      const response = await api.get('/users/verification-token');
      return response.data;
    } catch (error) {
      console.error('Error getting verification token:', error);
      throw error;
    }
  }
};

export default userService; 